import React, { Fragment, useState } from "react";

import { Dialog, Transition } from "@headlessui/react";
import ModalContent from "../ModalContent";
import Backend from "../../utils/Backend";
import {
  DepositMethods,
  DevType,
  UserBalances,
  UserWallets,
} from "../../typings";
import EventManager from "../../utils/EventManager";

type Args = {
  backend: Backend;
  publicKey: string;
  userId: string;
  depositMethods: DepositMethods;
  userBalances: UserBalances;
  events: EventManager;
  type: DevType;
  userFetchWalletAddresses: any;
  userWallets: UserWallets;
};
export default function ModalButton({
  backend,
  publicKey,
  userId,
  depositMethods,
  userBalances,
  events,
  type,
  userFetchWalletAddresses,
  userWallets,
}: Args) {
  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <Fragment>
      <div className="">
        <button
          type="button"
          onClick={openModal}
          className="rounded-r-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
        >
          Wallet
        </button>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <ModalContent
            closeModal={closeModal}
            backend={backend}
            publicKey={publicKey}
            userId={userId}
            depositMethods={depositMethods}
            userBalances={userBalances}
            events={events}
            type={type}
            userWallets={userWallets}
            userFetchWalletAddresses={userFetchWalletAddresses}
          ></ModalContent>
        </Dialog>
      </Transition>
    </Fragment>
  );
}
